import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'

import rootReducer from './reducers/index'

const persistConfig = {
  key: 'authType',
  version: 1,
  storage,
  whitelist: ['clients', 'servername', 'clientid', 'user', 'userInfo', 'affiliates', 'productCatalog', 'clientid'],
}

const reducer = persistReducer(persistConfig, rootReducer)
const store = configureStore({
  reducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
})
const persistor = persistStore(store)
export { persistor, store }
